<fw-dialog title="Promote to Shared Data Views" width="small">
  <fw-dialog-content [padded]="true">
    <fw-section-heading [description]="dialogDescription" />
    <form [formGroup]="form">
      <fw-layout-panel>
        <fw-form-heading title="Name" />
        <fw-text-input formControlName="label" placeholder="Name" test-id="name" />
      </fw-layout-panel>
      <fw-layout-panel>
        <fw-form-heading title="Description" />
        <fw-text-input formControlName="description" placeholder="Description" test-id="description" />
      </fw-layout-panel>
    </form>
  </fw-dialog-content>
  <fw-dialog-actions>
    <fw-button test-id="project-dialog-close" variant="outline" (click)="closeDialog()">Cancel</fw-button>
    <fw-button test-id="promote-data-view" [disabled]="form.disabled || !form.valid" (click)="onPromote()">
      Promote
    </fw-button>
  </fw-dialog-actions>
</fw-dialog>
